import { render, staticRenderFns } from "./production.view.vue?vue&type=template&id=cc2dbb58&"
import script from "./production.view.vue?vue&type=script&lang=ts&"
export * from "./production.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports